var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapIcon = function SvgMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.095 2.666 1.268 1.195.137 1.206.284-.05.638.34.665.87.248 1.008-.477 1.436-1.127.886.432.659-.239 1.826-1.163 1.015-1.084.276-1.675-.393-1.675.393-1.084-.276-1.163-1.015-.234-1.833.385-.581-.095-.007-1.083-1.03-.385-1.35.284-1.178.987-.993.639-.136.299-1.113.627-.825.55-.313 1.59.34.319.414.134-.2 1.04-.571zM6.584 8.439l-1.695 2.553 1.163 1.014 1.95-.456 1.95.456 1.163-1.014-1.339-2.044-.958-1.188-.798-.34zM4.189 6.4 3.905 7.58l1.082 1.03.48-.34.147-1.15-.627-.887zm6.2.72.185 1.148.365.221 1.16-.911-.248-1.008-.638-.34zM6.106 4.193 5.732 5.58l1.17 1.16.32-.169.326-1.527-.892-1.162zm2.35.85.363 1.527.48.17.974-1.161-.177-1.556h-.957z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.15,
    result: "effect1_innerShadow_6844_2935"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_6844_2935"
  })))));
};
export default SvgMapIcon;